export default __webpack_public_path__ + "static/favicon-4652c2a1465310b1f5cd5e71c2f33338.ico";